import { useState } from "react";
import { X } from "lucide-react";

export default function AddressForm({ onSave, onCancel }) {
  const [formData, setFormData] = useState({
    tipo: "Casa",
    nome: "",
    rua: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    cep: "",
    telefone: "",
    principal: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      id: Date.now().toString(),
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 max-w-2xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-900">
          Adicionar Endereço
        </h2>
        <button
          onClick={onCancel}
          className="text-gray-400 hover:text-gray-500">
          <X className="h-5 w-5" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label
              htmlFor="tipo"
              className="block text-sm font-medium text-gray-700">
              Tipo de Endereço
            </label>
            <select
              id="tipo"
              name="tipo"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.tipo}
              onChange={handleChange}>
              <option value="Casa">Casa</option>
              <option value="Trabalho">Trabalho</option>
              <option value="Outro">Outro</option>
            </select>
          </div>

          <div>
            <label
              htmlFor="nome"
              className="block text-sm font-medium text-gray-700">
              Rua
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label
              htmlFor="nome"
              className="block text-sm font-medium text-gray-700">
              Número
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label
              htmlFor="nome"
              className="block text-sm font-medium text-gray-700">
              Complemento
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label
              htmlFor="nome"
              className="block text-sm font-medium text-gray-700">
              Bairro
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label
              htmlFor="nome"
              className="block text-sm font-medium text-gray-700">
              Cidade
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label
              htmlFor="nome"
              className="block text-sm font-medium text-gray-700">
              Estado
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label
              htmlFor="nome"
              className="block text-sm font-medium text-gray-700">
              CEP
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Adicione os outros campos do formulário aqui... */}

        <div className="flex items-center">
          <input
            type="checkbox"
            id="principal"
            name="principal"
            className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
            checked={formData.principal}
            onChange={handleChange}
          />
          <label
            htmlFor="principal"
            className="ml-2 block text-sm text-gray-700">
            Tornar endereço principal
          </label>
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
            Cancelar
          </button>
          <button
            type="submit"
            className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
            Salvar Endereço
          </button>
        </div>
      </form>
    </div>
  );
}
